import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { Icon, Text, useSettings, TagsArray } from 'app/main/components';
import buttons from './SkillsButtons';

export default function SkillsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	return (
		<GridListItem buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.skll_warning_desc && (
								<Tooltip title={props.model.skll_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.skll_blocked_desc && (
								<Tooltip title={props.model.skll_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={`/skills/details/${props.model.skll_uid}`}
							>
								{props.model.skll_title}
							</Text>
						</Grid>
						{/* TAGS */}
						<Grid className="text-center">
							<TagsArray tags={props.model.skll_tags} changeFilter={props.changeFilter} />
						</Grid>
						{/* DESCRIPTION */}
						<Grid size={12}>
							<Text className="line-clamp-2" variant="subtitle2" color="textSecondary">
								{props.model.skll_description || <i>{t('VIEW_ITEM_NO_DESCRIPTION')}</i>}
							</Text>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
